import { render, staticRenderFns } from "./myOrders.vue?vue&type=template&id=547befb1&scoped=true"
import script from "./myOrders.vue?vue&type=script&lang=js"
export * from "./myOrders.vue?vue&type=script&lang=js"
import style0 from "./myOrders.vue?vue&type=style&index=0&id=547befb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547befb1",
  null
  
)

export default component.exports